const SintMaartenSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_112351)">
      <path
        d="M18.2605 21.7391C18.2605 21.7391 5.86914 5.85508 5.85742 5.85789C9.47664 2.23859 14.4767 0 19.9996 0C31.0452 0 39.9996 8.95437 39.9996 20L18.2605 21.7391Z"
        fill="#D80027"
      />
      <path
        d="M18.2605 20C18.2605 20 5.86914 34.1449 5.85742 34.1421C9.47664 37.7614 14.4767 40 19.9996 40C31.0452 40 39.9996 31.0456 39.9996 20H18.2605Z"
        fill="#0052B4"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.19268 20C2.18174 20.1436 2.17432 20.2883 2.17432 20.4347C2.17432 23.5562 4.70494 26.0869 7.8265 26.0869C10.9481 26.0869 13.4787 23.5562 13.4787 20.4347C13.4787 20.2883 13.4713 20.1435 13.4603 20H2.19268Z"
        fill="#FFDA44"
      />
      <path
        d="M7.82654 17.3914C8.78704 17.3914 9.56568 16.6127 9.56568 15.6522C9.56568 14.6917 8.78704 13.9131 7.82654 13.9131C6.86604 13.9131 6.0874 14.6917 6.0874 15.6522C6.0874 16.6127 6.86604 17.3914 7.82654 17.3914Z"
        fill="#FFDA44"
      />
      <path
        d="M3.91357 15.2168V20.869C3.91357 23.8643 7.82662 24.782 7.82662 24.782C7.82662 24.782 11.7397 23.8643 11.7397 20.869V15.2168H3.91357Z"
        fill="#D80027"
      />
      <path
        d="M7.8282 22.963C7.10227 22.7018 5.65234 22.0341 5.65234 20.8701V16.957H10.0002V20.8701C10.0002 22.038 8.55047 22.704 7.8282 22.963Z"
        fill="#338AF3"
      />
      <path
        d="M8.69539 19.1315V18.2619L7.82586 17.8271L6.95625 18.2619V19.1315L6.52148 19.5663V21.3054H9.13023V19.5663L8.69539 19.1315Z"
        fill="#F3F3F3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112351">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SintMaartenSvg;
